// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon, type IconProps } from '../BaseIcon'

export default (props: IconProps): JSX.Element => (
  <BaseIcon {...sanitizeProps(props)}>
    <path
      fillRule="evenodd"
      d="m17 10.46-1.36-1.38-3.18 3.2V2h-1.92v10.28l-3.18-3.2L6 10.46 11.5 16ZM18 18v2H6v-2H4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2Z"
    />
  </BaseIcon>
)
